import React, { memo } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useCookiesContext } from '../../contexts/CookiesContext'
import { tourModalTranslates } from '@revbox/localization'
import { useNavigate } from 'react-router-dom'
import { useJoyride } from '../../contexts/JoyrideContext'

const TourModal = memo(
    ({ onClose }) => {
        const { getLanguageAbbr } = useCookiesContext()
        const language = getLanguageAbbr()
        const multilang = tourModalTranslates[language]
        const navigate = useNavigate()
        const { triggerTour } = useJoyride()
        const handleStartTour = () => {
            if (window.location.pathname !== '/adv/home') {
                const urlSearchParams = new URLSearchParams(window.location.search)
                const advId = urlSearchParams.get('advId')
                const pubId = urlSearchParams.get('pub')
                const navigateTo = `adv/home?advId=${advId}&pub=${pubId}`
                navigate(navigateTo)
            }
            onClose()
            triggerTour()
        }

        return (
            <Modal show onHide={onClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{multilang.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{multilang.content}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={handleStartTour}
                    >
                        {multilang.button}
                    </Button>
                </Modal.Footer>
            </Modal >
        )
    }
)

export default TourModal
